import { forwardRef, useEffect, useState } from "react";
import { Input, type InputProps } from "./Input";

export interface NairaInputProps extends Omit<InputProps, "value" | "onChange" | "type"> {
  /** Value in kobo (null/undefined = empty). */
  valueKobo: number | null | undefined;
  onChangeKobo: (kobo: number | null) => void;
}

const fmt = new Intl.NumberFormat("en-NG", { maximumFractionDigits: 2 });

/** Naira amount input that shows "1,250,000" while the form stores integer kobo. */
export const NairaInput = forwardRef<HTMLInputElement, NairaInputProps>(function NairaInput({ valueKobo, onChangeKobo, ...rest }, ref) {
  const [text, setText] = useState(valueKobo == null ? "" : fmt.format(valueKobo / 100));
  useEffect(() => {
    const parsed = Math.round(Number(text.replace(/[^\d.]/g, "")) * 100);
    if ((valueKobo ?? null) !== (text === "" ? null : parsed)) setText(valueKobo == null ? "" : fmt.format(valueKobo / 100));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only resync when the external value changes
  }, [valueKobo]);
  return (
    <Input
      ref={ref}
      inputMode="decimal"
      leading={<span className="tabular text-sm">₦</span>}
      className="tabular"
      value={text}
      onChange={(e) => {
        const raw = e.target.value.replace(/[^\d.]/g, "");
        const [whole = "", frac] = raw.split(".");
        const cleaned = frac !== undefined ? `${whole}.${frac.slice(0, 2)}` : whole;
        setText(cleaned === "" ? "" : `${fmt.format(Number(whole || "0"))}${frac !== undefined ? `.${frac.slice(0, 2)}` : ""}`);
        onChangeKobo(cleaned === "" ? null : Math.round(Number(cleaned) * 100));
      }}
      {...rest}
    />
  );
});
